import React from "react"
import "./SocialShare.scss"
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton
  } from "react-share";
import sticker from "../../images/stickers_phonesmartjoin-in.png"

const SocialShare = (category) => {
  const shareUrl = 'https://eephonesmart.co.uk/';
  const title = 'Get your PhoneSmart License. #PhoneSmart';
  const twitterDataUrl = "https://twitter.com/i/flow/login?redirect_after_login=%2Fshare%3Furl%3Dhttps%253A%252F%252Feephonesmart.co.uk%252F%26text%3DGet%2520your%2520PhoneSmart%2520License.%2520%2523PhoneSmart";
  const facebookDataUrl = "https://www.facebook.com/login.php?skip_api_login=1&api_key=966242223397117&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fsharer%2Fsharer.php%3Fu%3Dhttps%253A%252F%252Feephonesmart.co.uk%252F&cancel_url=https%3A%2F%2Fwww.facebook.com%2Fdialog%2Fclose_window%2F%3Fapp_id%3D966242223397117%26connect%3D0%23_%3D_&display=popup&locale=en_GB";
  const whatsappDataUrl = "https://web.whatsapp.com";

	return (
		<div className="socialshare">
            
			<img src={sticker} className="social-sticker" alt="sticker"/>
			<div className="socialtext">
				<p>Share PhoneSmart with your friends and family</p>
				<div className="socialimages">
				
            <TwitterShareButton
            url={shareUrl}
            title={title}
            className="twitter"
            data-analytics={`{"event":"social_share", "loginStatus":"logged-in", "actionType":"Share to Twitter", "clickText":"PhoneSmart with friends", "linkType":"external", "linkUrl":"${twitterDataUrl}", "moduleName":"${category.eventcategory}- Social Interaction", "pageName":"Grown up Dashboard", "userType":"parent"}`} 
          >
           
          </TwitterShareButton>

        <FacebookShareButton
            url={shareUrl}
            title="get your phonemsart"
            className="fb"
            data-analytics={`{"event":"social_share", "loginStatus":"logged-in", "actionType":"Share to Facebook", "clickText":"PhoneSmart with friends", "linkType":"external", "linkUrl":"${facebookDataUrl}", "moduleName":"${category.eventcategory}- Social Interaction", "pageName":"Grown up Dashboard", "userType":"parent"}`}
          >
          </FacebookShareButton>


          <WhatsappShareButton
            url={shareUrl}
            title="get your phonemsart"
            className="whasapp"
            data-analytics={`{"event":"social_share", "loginStatus":"logged-in", "actionType":"Share to Whatsapp", "clickText":"PhoneSmart with friends", "linkType":"external", "linkUrl":"${whatsappDataUrl}", "moduleName":"${category.eventcategory}- Social Interaction", "pageName":"Grown up Dashboard", "userType":"parent"}`}
          >
          </WhatsappShareButton>
				
			
				</div>
			</div>	
		</div>
	)
}

export default SocialShare